export const encryptBase64 = (value: string): string => btoa(value)
export const decryptBase64 = (value: string): string => atob(value)
